import { Injectable } from '@angular/core';
import {
  FulfillmentOrder,
  FulfillmentOrderApiService,
  GetFulfillmentOrdersForSalesOrderRequest,
  GetFulfillmentOrdersForSalesOrderResponse,
} from '@vendasta/order-fulfillment';
import { BehaviorSubject, EMPTY, iif, Observable } from 'rxjs';
import { catchError, expand, publishReplay, refCount, scan, take, tap } from 'rxjs/operators';

const PAGE_SIZE = 200;

@Injectable({
  providedIn: 'root',
})
export class WorkOrderSalesOrderSummaryService {
  private loadingWorkOrders$$: BehaviorSubject<boolean> = new BehaviorSubject(false);
  public readonly loadingWorkOrders$: Observable<boolean> = this.loadingWorkOrders$$.asObservable();

  constructor(private fulfillmentOrderApiService: FulfillmentOrderApiService) {}

  getWorkOrdersForSalesOrder(salesOrderId: string, businessId: string): Observable<FulfillmentOrder[]> {
    this.loadingWorkOrders$$.next(true);
    return this.fulfillmentOrderApiService
      .getFulfillmentOrdersForSalesOrder(
        new GetFulfillmentOrdersForSalesOrderRequest({
          salesOrderId,
          businessId,
          pageSize: PAGE_SIZE,
        }),
      )
      .pipe(
        take(1),
        expand((resp: GetFulfillmentOrdersForSalesOrderResponse) =>
          iif(
            () => resp?.hasMore,
            this.fulfillmentOrderApiService.getFulfillmentOrdersForSalesOrder(
              new GetFulfillmentOrdersForSalesOrderRequest({
                salesOrderId,
                businessId,
                pageSize: PAGE_SIZE,
                cursor: resp?.nextCursor,
              }),
            ),
            EMPTY,
          ),
        ),
        scan((prev: FulfillmentOrder[], curr: GetFulfillmentOrdersForSalesOrderResponse) => {
          if (curr?.fulfillmentOrders?.length > 0) {
            prev.push(...curr.fulfillmentOrders);
          }
          return prev;
        }, []),
        catchError((err) => {
          this.loadingWorkOrders$$.next(false);
          throw err;
        }),
        publishReplay(1),
        refCount(),
        tap(() => this.loadingWorkOrders$$.next(false)),
      );
  }
}
